/*
 * Filter and sort, on a phone, from one button.
 *
 * Neither control is new. Filter opens the rail that is already in the page,
 * using the same is-open class its own toggle uses, so a filter chosen from
 * the sheet behaves exactly as one chosen from the sidebar. Sort is a select
 * at the top of that same sheet and commits by setting sort_by in the URL,
 * which is what the head-row select does.
 *
 * Everything here is additive: with no JavaScript the rail and the select are
 * still on the page and still work, and the bar hides itself rather than
 * sitting there inert.
 */
(function () {
  'use strict';

  function init() {
    var bar = document.querySelector('[data-az-actionbar]');
    if (!bar) return;

    var rail = document.querySelector('.az-rail');
    var lastFocus = null;

    // Nothing to drive means no bar, rather than a button that does nothing.
    if (!rail) { bar.hidden = true; return; }
    bar.setAttribute('data-az-ready', '');

    function lockScroll(on) {
      document.body.style.overflow = on ? 'hidden' : '';
    }

    /* ------------------------------------------------------------ filters */
    var openFilters = bar.querySelector('[data-az-open-filters]');
    if (openFilters && rail) {
      openFilters.addEventListener('click', function () {
        lastFocus = openFilters;
        /*
         * Moved to the body, for the same reason the search sheet is. A sheet
         * is `position: fixed; inset: 0`, which means the viewport only while
         * no ancestor carries a transform. Dawn wraps sections in
         * div.scroll-trigger.animate--slide-in with transform: matrix(1,0,0,1,0,0),
         * an identity transform that changes nothing visually and still makes
         * the element a containing block. The search panel opened 4864px long
         * with its Apply bar off the bottom of the screen because of it. This
         * rail is not under that wrapper today; the theme is one editor drag
         * away from it being.
         */
        if (rail.parentNode !== document.body) {
          if (!railSlot) railSlot = document.createComment('az-rail');
          rail.parentNode.insertBefore(railSlot, rail);
          document.body.appendChild(rail);
        }
        rail.classList.add('is-open', 'az-rail--sheet');

        /*
         * THE FACETS STAY SHUT HERE TOO, by instruction.
         *
         * They were opened on this line for a while: a sheet covers the screen
         * and nobody reaches it by accident, so a closed group is a second
         * press to find out whether the size you want is even listed, and four
         * headings over a mostly blank screen reads as a filter that does not
         * work. That was the call, it was asked to be reversed, and closed is
         * what ships. Written down so the next person does not read the blank
         * space as a bug and open them again.
         *
         * The rows themselves are 44px on a phone, which is the part that
         * actually was broken: at 36px a thumb lands between two sizes and the
         * filter looks unresponsive whatever is open.
         */

        stage();
        lockScroll(true);
        var first = rail.querySelector('summary, button, a, input');
        if (first) first.focus();
      });

      // The rail draws its own close control only in sheet mode.
      rail.addEventListener('click', function (e) {
        if (!e.target.closest('[data-az-rail-close]')) return;
        closeFilters();
      });
    }

    var railSlot = null;

    function closeFilters() {
      if (!rail) return;
      rail.classList.remove('is-open', 'az-rail--sheet');
      if (railSlot && railSlot.parentNode) {
        railSlot.parentNode.insertBefore(rail, railSlot);
        railSlot.parentNode.removeChild(railSlot);
        railSlot = null;
      }
      lockScroll(false);
      if (lastFocus) lastFocus.focus();
    }

    /*
     * The rail is a collapsible block between 750 and 990, where it sits full
     * width above the grid rather than beside it. The sheet uses the same
     * is-open class, so one toggle drives both.
     */
    var railToggle = rail && rail.querySelector('[data-az-rail-toggle]');
    if (railToggle) {
      railToggle.addEventListener('click', function () {
        var on = !rail.classList.contains('is-open');
        rail.classList.toggle('is-open', on);
        railToggle.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
    }

    /* ----------------------------------------------------- staged filters */
    /*
     * In the sidebar every facet value is a link and that is right: the
     * results are in view beside it, so one tap, one reload, and the shopper
     * sees what it did. In a sheet that covers the screen the same link means
     * one reload per choice and the sheet gone each time, so picking a brand
     * and two sizes is three round trips and three reopenings.
     *
     * So inside the sheet the taps are staged here and committed once. The
     * links are left exactly as they are: with no JavaScript, or on a desktop,
     * they still carry their own url_to_add.
     */
    var applyBar = rail && rail.querySelector('[data-az-rail-apply]');
    var goCount = applyBar && applyBar.querySelector('[data-az-rail-n]');
    var pending = null;

    function inSheet() {
      return !!rail && rail.classList.contains('az-rail--sheet');
    }

    function stage() {
      pending = new URLSearchParams(window.location.search);
      paint();
    }

    // Shopify repeats the parameter name for a multi-select facet, so a single
    // delete/set would collapse three chosen brands into one.
    function toggleValue(param, value) {
      var all = pending.getAll(param);
      var i = all.indexOf(value);
      if (i === -1) all.push(value); else all.splice(i, 1);
      pending.delete(param);
      all.forEach(function (v) { pending.append(param, v); });
    }

    function countFilters() {
      var n = 0;
      pending.forEach(function (v, k) { if (k.indexOf('filter.') === 0) n++; });
      return n;
    }

    function paint() {
      if (!pending) return;
      var opts = rail.querySelectorAll('[data-az-param]');
      for (var i = 0; i < opts.length; i++) {
        var el = opts[i];
        var on = pending.getAll(el.getAttribute('data-az-param'))
          .indexOf(el.getAttribute('data-az-value')) > -1;
        el.classList.toggle('is-staged', on);
        var box = el.querySelector('input[type="checkbox"]');
        if (box) box.checked = on;
      }
      if (goCount) {
        var n = countFilters();
        goCount.textContent = n ? ' \u00b7 ' + n : '';
        goCount.hidden = n === 0;
      }
    }

    function commit() {
      var url = new URL(window.location.href);
      url.search = pending.toString();
      // Price is typed, not tapped, so it is read at commit time.
      var price = rail.querySelectorAll('.az-price input[name]');
      for (var i = 0; i < price.length; i++) {
        var v = price[i].value.trim();
        if (v) url.searchParams.set(price[i].name, v);
        else url.searchParams.delete(price[i].name);
      }
      // Sort is the first row of the same panel, so it commits with the rest.
      var sortSel = rail.querySelector('[data-az-sheet-sort]');
      if (sortSel && sortSel.value) url.searchParams.set('sort_by', sortSel.value);

      // A new set of filters is a new first page.
      url.searchParams.delete('page');
      window.location.href = url.toString();
    }

    if (rail && applyBar) {
      rail.addEventListener('click', function (e) {
        if (!inSheet() || !pending) return;

        var opt = e.target.closest('[data-az-param]');
        if (opt && rail.contains(opt)) {
          e.preventDefault();
          toggleValue(opt.getAttribute('data-az-param'), opt.getAttribute('data-az-value'));
          paint();
          return;
        }

        var clear = e.target.closest('[data-az-clear-param]');
        if (clear) {
          e.preventDefault();
          clear.getAttribute('data-az-clear-param').split(',').forEach(function (k) {
            pending.delete(k.trim());
          });
          var box = clear.closest('.az-facet__body');
          if (box) {
            var ins = box.querySelectorAll('.az-price input[name]');
            for (var i = 0; i < ins.length; i++) ins[i].value = '';
          }
          paint();
          return;
        }

        if (e.target.closest('[data-az-rail-clear]')) {
          e.preventDefault();
          var keys = [];
          pending.forEach(function (v, k) { if (k.indexOf('filter.') === 0) keys.push(k); });
          keys.forEach(function (k) { pending.delete(k); });
          var all = rail.querySelectorAll('.az-price input[name]');
          for (var j = 0; j < all.length; j++) all[j].value = '';
          paint();
          return;
        }

        if (e.target.closest('[data-az-rail-go]')) {
          e.preventDefault();
          commit();
        }
      });

      // The price form has its own submit button for the sidebar. In the sheet
      // it is hidden, but Enter in a text input still submits the form.
      rail.addEventListener('submit', function (e) {
        if (!inSheet() || !pending) return;
        e.preventDefault();
        commit();
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (rail.classList.contains('az-rail--sheet')) closeFilters();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
